/* eslint-disable react/prop-types */
import React from 'react'
import { useSvg } from 'irmlib/hooks'

/**
 * @function
 * @description JobManagement
 * @param {object} props props.
 * @param {string} props.fill Fill color for the icon. By default, it picks up the color of the nearest parent.
 * @param {number} props.scale Scale for the size of the icon. The default is 1.
 * @returns {object} svg of the icon
 */
export default props => {
  const viewBoxWidth = 24
  const viewBoxHeight = 24
  const [, width, height] = useSvg(props, viewBoxWidth, viewBoxHeight)
  return (
    <svg width={width} height={height} viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`} version='1.1' xmlns='http://www.w3.org/2000/svg'>
      <g id="MDI_format-list-checks" data-name="MDI / format-list-checks" opacity="0.6">
        <g id="Boundary" stroke="rgba(0,0,0,0)" strokeWidth="1" opacity="0">
          <rect width="24" height="24" stroke="none"/>
          <rect x="0.5" y="0.5" width="23" height="23" fill="none"/>
        </g>
        <path id="Path_format-list-checks" data-name="Path / format-list-checks" d="M3,5H9v6H3V5M5,7V9H7V7H5m6,0H21V9H11V7m0,8H21v2H11V15M5,20,1.5,16.5l1.41-1.41L5,17.17l4.59-4.58L11,14Z" transform="translate(0.5)"/>
      </g>
    </svg>
  )
}
